import { TFunction } from 'i18next';

/**
 * Коды ошибок журнала поиска → ключи локали (ТЗ 0069).
 *
 * 🔴 `errorMessage` с сервера НИКОГДА не показываем: он по-русски, а интерфейс
 * по-польски. Правило домена, оплаченное однажды.
 */
const MESSAGES: Record<string, string> = {
  not_a_member: 'careerCenter.applications.errors.notAMember',
  not_found: 'careerCenter.applications.errors.notFound',
  invalid: 'careerCenter.applications.errors.invalid',
  application_locked: 'careerCenter.applications.errors.locked',
};

export const getCareerJourneyErrorText = (t: TFunction, code?: string | null): string =>
  t(MESSAGES[code ?? ''] ?? 'careerCenter.applications.errors.invalid');
